export default (
  <>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.18934 3.43934C4.47064 3.15804 4.85217 3 5.25 3H9C9.41421 3 9.75 3.33579 9.75 3.75C9.75 4.16421 9.41421 4.5 9 4.5H5.25L5.25 20.25H18.75V4.5H15C14.5858 4.5 14.25 4.16421 14.25 3.75C14.25 3.33579 14.5858 3 15 3H18.75C19.1478 3 19.5294 3.15804 19.8107 3.43934C20.092 3.72065 20.25 4.10218 20.25 4.5V20.25C20.25 20.6478 20.092 21.0294 19.8107 21.3107C19.5294 21.592 19.1478 21.75 18.75 21.75H5.25C4.85218 21.75 4.47065 21.592 4.18934 21.3107C3.90804 21.0294 3.75 20.6478 3.75 20.25V4.5C3.75 4.10217 3.90804 3.72064 4.18934 3.43934Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 3C11.2044 3 10.4413 3.31607 9.87868 3.87868C9.31607 4.44129 9 5.20435 9 6H15C15 5.20435 14.6839 4.44129 14.1213 3.87868C13.5587 3.31607 12.7956 3 12 3ZM8.81802 2.81802C9.66193 1.97411 10.8065 1.5 12 1.5C13.1935 1.5 14.3381 1.97411 15.182 2.81802C16.0259 3.66193 16.5 4.80653 16.5 6V6.75C16.5 7.16421 16.1642 7.5 15.75 7.5H8.25C7.83579 7.5 7.5 7.16421 7.5 6.75V6C7.5 4.80653 7.97411 3.66193 8.81802 2.81802Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.4255 10.4927C16.7183 10.7856 16.7183 11.2605 16.4255 11.5534L11.4715 16.5073C11.1786 16.8002 10.7038 16.8002 10.4109 16.5073L8.24354 14.34C7.95064 14.0471 7.95064 13.5722 8.24354 13.2793C8.53643 12.9864 9.0113 12.9864 9.30419 13.2793L10.9412 14.9163L15.3648 10.4927C15.6577 10.1998 16.1326 10.1998 16.4255 10.4927Z"
      fill="currentColor"
    />
  </>
);
